import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSearchParams} from "react-router-dom";

import './tabs.scss';

function Tabs(
    {
        items,
        container_class = '',
        menu_wrapper_class = '',
        menu_container_class = '',
        menu_class = '',
        content_class = '',
        item_class = '',
        link_class = '',
        use_query_string = false,
        extra_menu_content
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab_key, setTabKey] = useState(items[0].key);
    const param = searchParams.get('tab');

    function onClick(item) {
        return event => {
            event.preventDefault();
            if (use_query_string) {
                searchParams.set('tab', item.key);
                setSearchParams(searchParams);
            }
            setTabKey(item.key);
            if (item.hasOwnProperty('onClickCallback') && typeof item.onClickCallback === 'function') {
                item.onClickCallback();
            }
        }
    }

    function renderExtra() {
        if (extra_menu_content) {
            return (
                <div className='mindsets-tabs-menu-extra'>{extra_menu_content}</div>
            );
        }

        return null;
    }

    function renderMenu() {
        return (
            <div className={'mindsets-tabs-menu-wrapper ' + menu_wrapper_class}>
                <div className={'mindsets-tabs-menu-container ' + menu_container_class}>
                    <div className={'mindsets-tabs-menu ' + menu_class}>
                        {items.map(item => {
                            return (
                                <div
                                    key={item.key}
                                    className={'mindsets-tabs-menu-item ' + item_class + ' ' + (tab_key === item.key ? 'active' : '')}
                                >
                                    <a
                                        href={'!#'}
                                        className={'mindsets-tabs-menu-item-link ' + link_class}
                                        onClick={onClick(item)}
                                    >{item.name}</a>
                                </div>
                            );
                        })}
                    </div>
                    {renderExtra()}
                </div>
            </div>
        );
    }

    function renderContent() {
        if (items.map(item => item.key).includes(tab_key)) {
            const tab = items.find(item => item.key === tab_key);
            return (
                <div className={'mindsets-tabs-content ' + content_class}>{tab.content}</div>
            );
        }

        return null;
    }

    useEffect(() => {
        if (use_query_string && searchParams.has('tab') && items.map(item => item.key).includes(searchParams.get('tab'))) {
            setTabKey(searchParams.get('tab'));
        }
    }, []);

    useEffect(() => {
        if (use_query_string && searchParams.has('tab') && items.map(item => item.key).includes(searchParams.get('tab')) && tab_key !== searchParams.get('tab')) {
            setTabKey(searchParams.get('tab'));
        }
    }, [param]);

    return (
        <div className={'mindsets-tabs ' + container_class}>
            {renderMenu()}
            {renderContent()}
        </div>
    );
}

Tabs.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        content: PropTypes.element.isRequired,
        onClickCallback: PropTypes.func
    })).isRequired,
    container_class: PropTypes.string,
    menu_wrapper_class: PropTypes.string,
    menu_container_class: PropTypes.string,
    menu_class: PropTypes.string,
    content_class: PropTypes.string,
    item_class: PropTypes.string,
    link_class: PropTypes.string,
    use_query_string: PropTypes.bool,
    extra_menu_content: PropTypes.element
}

export default Tabs
